export class Document {
    private queue: any = [];

    loadJs(fn: any) {
        this.queue.push(fn);

        window.onload = () => this.execute();

    }

    private execute(): void {
        for (const fn of this.queue) {
            fn();
        }
    }
}
